export function removeFromLocalStorage(uid, checklistUID) {
  let storedChecklists = JSON.parse(localStorage.getItem(uid));
  delete storedChecklists[checklistUID];
  if (Object.keys(storedChecklists).length === 0) {
    localStorage.removeItem(uid);
  } else {
    localStorage.setItem(uid, JSON.stringify(storedChecklists));
  }
}
